/**
 * Put transcribed words where the caret is, not at the end of the box.
 *
 * A person who taps the mic mid-sentence means "here"; the selection, if any, is
 * what they meant to replace. Spaces are added only where the join would otherwise
 * glue two words together, and never against the box's edges or an existing space —
 * so dictating into an empty composer inserts the words alone, and dictating after
 * "Fix the" yields "Fix the bug", not "Fix the  bug" or "Fix thebug". CJK has no
 * inter-word space, so a Han neighbour gets none.
 */
const HAN = /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}]/u

function needsSpaceBetween(left: string, right: string): boolean {
  if (!left || !right) return false
  if (/\s/.test(left) || /\s/.test(right)) return false
  if (HAN.test(left) || HAN.test(right)) return false
  return true
}

export function insertAtCaret(
  value: string,
  start: number,
  end: number,
  text: string,
): { value: string; caret: number } {
  const from = Math.max(0, Math.min(start, end, value.length))
  const to = Math.max(from, Math.min(Math.max(start, end), value.length))
  const words = text.trim()
  if (!words) return { value, caret: to }
  const before = value.slice(0, from)
  const after = value.slice(to)
  const lead = needsSpaceBetween(before.slice(-1), words[0] ?? '') ? ' ' : ''
  const trail = needsSpaceBetween(words.slice(-1), after[0] ?? '') ? ' ' : ''
  const inserted = `${lead}${words}${trail}`
  return { value: before + inserted + after, caret: before.length + inserted.length }
}
